//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { useDispatch } from "react-redux";
// other components
// state
import {
  setActiveViewDay,
  setActiveViewTeamHealth,
} from "#webapp/src/state/actions/chrome-extension.actions";
// util
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
// material-ui
import { Button } from "@clockwise/design-system";
import { ChevronLeft } from "@clockwise/design-system/icons";
import { Tooltip } from "@material-ui/core";

//////////////////
// TYPES
//////////////////
type ChromeNavBackBtnProps = {
  backDestination?: ChromeAppWrapperView;
  onBack?: () => void;
};

export const ChromeNavBackBtn = ({ backDestination, onBack }: ChromeNavBackBtnProps) => {
  const dispatch = useDispatch();

  const onClick = () => {
    switch (backDestination) {
      case ChromeAppWrapperView.Day:
        dispatch(setActiveViewDay());
        break;
      case ChromeAppWrapperView.TeamHealth:
      default:
        dispatch(setActiveViewTeamHealth());
        break;
    }

    onBack && onBack();
  };

  const toolTipLabel = () => {
    switch (backDestination) {
      case ChromeAppWrapperView.TeamHealth:
        return "Teammates";
      default:
        return "Home"; // FIXME
    }
  };

  return (
    <div className="cw-m-1">
      <Tooltip title={toolTipLabel()} placement="bottom">
        <Button
          variant="text"
          startIcon={ChevronLeft}
          aria-label="Go back"
          onClick={onClick}
          cw-id="chrome-nav-back-button"
        />
      </Tooltip>
    </div>
  );
};
